import * as Highcharts from "highcharts";

export const barpartA = {
  chart: { type: "column" },
  title: { text: "" },
  xAxis: { categories: ["All"] },
  yAxis: {
    min: 0,
    max: 110,
    title: { text: "Percentage" },
    stackLabels: { enabled: false }
  },
  marker: { enabled: false },
  tooltip: {
    headerFormat: "<b>{point.x}</b><br/>",
    pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}"
  },
  plotOptions: {
    column: { stacking: "normal", dataLabels: { enabled: false } }
  },
  series: [
    { name: "Under Process", color: "#C6CDD4", data: [15] },
    { name: "SLA", color: "#007FD8", data: [80] }
  ]
};

export const barpartB = {
  chart: { zoomType: "xy", type: "column" },
  title: { text: "", align: "left" },
  xAxis: [
    {
      categories: ["North", "South", "East", "West"],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: { format: "{value}%" },
      title: { text: "Percentage" }
    },
    {
      // Secondary yAxis
      title: { text: "Volume (Crores)" },
      labels: { format: "{value} crore" },
      opposite: true
    }
  ],
  plotOptions: {
    column: {
      stacking: "normal"
    }
  },
  tooltip: { shared: true },
  series: [
    {
      name: "Under Process",
      data: [7.0, 6.9, 9.5, 14],
      stack: "A",
      color: "#C6CDD4",
      tooltip: { valueSuffix: "crore" }
    },
    {
      name: "SLA ",
      data: [49.9, 71.5, 80.4, 92.2],
      stack: "A",
      color: "#007FD8",
      tooltip: { valueSuffix: "%" }
    },
    {
      name: "Volume",
      data: [7.0, 6.9, 9.5, 14],
      stack: "B",
      yAxis: 1,
      color: "#909dc0",
      tooltip: { valueSuffix: "crore" }
    }
  ]
};

export const dualLine = {
  chart: { zoomType: "xy" },
  title: { text: "", align: "left", style: { fontWeight: "bold" } },
  xAxis: [
    {
      categories: [
        "1Jul",
        "2Jul",
        "3Jul",
        "4Jul",
        "5Jul",
        "6Jul",
        "7Jul",
        "8Jul",
        "9Jul",
        "10Jul",
        "11Jul"
      ],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}%",
        style: { color: Highcharts.getOptions().colors[1] }
      },
      title: {
        text: "Percentage",
        style: { color: Highcharts.getOptions().colors[1] }
      }
    },
    {
      // Secondary yAxis
      title: {
        text: "Volume",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      labels: {
        format: "{value} crore",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      opposite: true
    }
  ],
  tooltip: { shared: true },
  series: [
    {
      name: "Percentage",
      type: "line",
      data: [49.9, 71.5, 80.4, 92.2, 70.0, 76.0, 35.6, 48.5, 86.4, 94.1, 95.6],
      tooltip: { valueSuffix: "%" }
    },
    {
      name: "Volume",
      type: "line",
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9],
      tooltip: { valueSuffix: "crore" }
    }
  ]
};
export const dualLine2 = {
  chart: { zoomType: "xy" },
  title: {
    text: "",
    align: "left",
    style: { fontWeight: "bold" }
  },
  xAxis: [
    {
      categories: [
        "1Jul",
        "2Jul",
        "3Jul",
        "4Jul",
        "5Jul",
        "6Jul",
        "7Jul",
        "8Jul",
        "9Jul",
        "10Jul",
        "11Jul"
      ],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}%",
        style: { color: Highcharts.getOptions().colors[1] }
      },
      title: {
        text: "Percentage",
        style: { color: Highcharts.getOptions().colors[1] }
      }
    },
    {
      // Secondary yAxis
      title: {
        text: "Volume",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      labels: {
        format: "{value} crore",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      opposite: true
    }
  ],
  tooltip: { shared: true },
  series: [
    {
      name: "SLA",
      type: "line",
      data: [49.9, 71.5, 80.4, 92.2, 70.0, 76.0, 35.6, 48.5, 86.4, 94.1, 95.6],
      tooltip: { valueSuffix: "%" }
    },
    {
      name: "Volume",
      type: "line",
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9],
      tooltip: { valueSuffix: "crore" }
    }
  ]
};
export const dualLine3 = {
  chart: { zoomType: "xy" },
  title: {
    text: "",
    align: "left",
    style: { fontWeight: "bold" }
  },
  xAxis: [
    {
      categories: [
        "1Jul",
        "2Jul",
        "3Jul",
        "4Jul",
        "5Jul",
        "6Jul",
        "7Jul",
        "8Jul",
        "9Jul",
        "10Jul",
        "11Jul"
      ],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}%",
        style: { color: Highcharts.getOptions().colors[1] }
      },
      title: {
        text: "Percentage",
        style: { color: Highcharts.getOptions().colors[1] }
      }
    },
    {
      // Secondary yAxis
      title: {
        text: "Volume",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      labels: {
        format: "{value} crore",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      opposite: true
    }
  ],
  tooltip: { shared: true },
  series: [
    {
      name: "SLA",
      type: "line",
      data: [49.9, 71.5, 80.4, 92.2, 70.0, 76.0, 35.6, 48.5, 86.4, 94.1, 95.6],
      tooltip: { valueSuffix: "%" }
    },
    {
      name: "Volume",
      type: "line",
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9],
      tooltip: { valueSuffix: "crore" }
    }
  ]
};
export const dualLine4 = {
  chart: { zoomType: "xy" },
  title: {
    text: "",
    align: "left",
    style: { fontWeight: "bold" }
  },
  xAxis: [
    {
      categories: [
        "1Jul",
        "2Jul",
        "3Jul",
        "4Jul",
        "5Jul",
        "6Jul",
        "7Jul",
        "8Jul",
        "9Jul",
        "10Jul",
        "11Jul"
      ],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}%",
        style: { color: Highcharts.getOptions().colors[1] }
      },
      title: {
        text: "Percentage",
        style: { color: Highcharts.getOptions().colors[1] }
      }
    },
    {
      // Secondary yAxis
      title: {
        text: "Volume",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      labels: {
        format: "{value} crore",
        style: { color: Highcharts.getOptions().colors[0] }
      },
      opposite: true
    }
  ],
  tooltip: { shared: true },
  series: [
    {
      name: "SLA",
      type: "line",
      data: [49.9, 71.5, 80.4, 92.2, 70.0, 76.0, 35.6, 48.5, 86.4, 94.1, 95.6],
      tooltip: { valueSuffix: "%" }
    },
    {
      name: "Volume",
      type: "line",
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9],
      tooltip: { valueSuffix: "crore" }
    }
  ]
};

export const dualBar = {
  chart: { zoomType: "xy" },
  title: {
    text: "",
    align: "left",
    style: { fontWeight: "bold" }
  },
  legend: {
    padding: 0,
    itemMarginTop: 14,
    enabled: true,
    itemMarginBottom: -10,
    itemStyle: {
      color: "#6b778c",
      fontWeight: "normal"
    }
  },
  xAxis: [{ categories: ["North", "South", "East", "West"], crosshair: true }],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}%",
        style: { color: Highcharts.getOptions().colors[1], fontSize: "12px" }
      },
      title: {
        text: "Percentage",
        style: { color: Highcharts.getOptions().colors[1] }
      }
    },
    {
      // Secondary yAxis
      labels: {
        format: "{value}",
        style: { color: "#434348", fontSize: "12px" }
      },
      title: {
        text: "Quantity",
        style: { color: "#434348" }
      },
      opposite: true
    }
  ],
  tooltip: { shared: true },
  series: [
    {
      name: "SLA",
      type: "column",
      data: [49.9, 71.5, 80.4, 92.2],
      tooltip: { valueSuffix: " %" },
      color: "#007fd8"
    },
    {
      name: "Quantity (Units)",
      type: "column",
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14],
      tooltip: { valueSuffix: " units" },
      color: "#909dc0"
    }
  ]
};
export const columnRangeChart = {
  chart: { type: "columnrange" },
  title: { text: "" },
  xAxis: {
    categories: [
      "OTIF",
      "OT Partial",
      "In Full Delayed",
      "Partial Delayed",
      "Deferred",
      "Under Process"
    ]
  },
  yAxis: { title: { text: "Percentage" }, min: 90, max: 100 },
  plotOptions: {
    columnrange: {
      colorByPoint: true,
      colors: [
        "#007fd8",
        "#ed8e88",
        "#e66e6d",
        "#de4f53",
        "#cf263d",
        "#c5ced5"
      ],
      dataLabels: { enabled: false }
    }
  },
  legend: { enabled: false },
  series: [
    {
      type: "columnrange",
      name: "Overall SLA",
      data: [[90, 94], [94, 95], [95, 96], [96, 97], [97, 99], [99, 100]]
    }
  ]
};
export const donutChart = {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: "pie"
  },
  title: {
    useHTML: true,
    text: "<strong></strong><br/>Failed OTIF orders",
    align: "center",
    verticalAlign: "middle",
    y: -10
  },
  tooltip: {
    pointFormat: "{series.name}: <b>{point.y}, {point.percentage:.1f}%</b>"
  },
  plotOptions: {
    pie: {
      colors: ["#EBC844", "#73C8B1", "#F4902D"],
      dataLabels: { enabled: false },
      showInLegend: true
    }
  },
  series: [
    {
      type: "pie",
      name: "Failed",
      innerSize: "70%",
      data: [["Planning", 300], ["Warehouse", 30], ["Transportation", 30]]
    }
  ]
};
export const donutChart2 = {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: "pie"
  },
  title: {
    text: ""
  },
  tooltip: { pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>" },
  plotOptions: {
    pie: {
      colors: ["#EBC844", "#73C8B1", "#F4902D"],
      dataLabels: { enabled: false },
      showInLegend: true
    }
  },
  series: [
    {
      type: "pie",
      name: "Failure Reasons",
      innerSize: "70%",
      data: [
        ["Original Warehouse", 34],
        ["Destination Warehouse", 34],
        ["Transportation", 34]
      ]
    }
  ]
};
export const donutChart3 = {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: "pie"
  },
  title: {
    text: ""
  },
  tooltip: { pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>" },
  plotOptions: {
    pie: {
      colors: ["#EBC844", "#73C8B1", "#F4902D"],
      dataLabels: { enabled: false },
      showInLegend: true
    }
  },
  series: [
    {
      type: "pie",
      name: "Failure Reasons",
      innerSize: "70%",
      data: [
        ["Original Warehouse", 20],
        ["Destination Warehouse", 30],
        ["Transportation", 10]
      ]
    }
  ]
};
export const donutChart4 = {
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: "pie"
  },
  title: {
    text: ""
  },
  tooltip: { pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>" },
  plotOptions: {
    pie: {
      colors: ["#EBC844", "#73C8B1", "#F4902D"],
      dataLabels: { enabled: false },
      showInLegend: true
    }
  },
  series: [
    {
      type: "pie",
      name: "Failure Reasons",
      innerSize: "70%",
      data: [
        ["Original Warehouse", 58.9],
        ["Destination Warehouse", 13.29],
        ["Transportation", 13]
      ]
    }
  ]
};
export const areaChart = {
  chart: { type: "area" },
  title: { text: "" },
  subtitle: { text: "", align: "left" },
  xAxis: {
    categories: [
      "4 Jul 19",
      "5 Jul 19",
      "6 Jul 19",
      "7 Jul 19",
      "8 Jul 19",
      "8 Jul 19",
      "10 Jul 19"
    ],
    tickmarkPlacement: "on",
    title: { enabled: false }
  },
  yAxis: { title: { text: "Percent" }, min: 88 },
  tooltip: {
    pointFormat:
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f} millions)<br/>',
    split: true
  },
  plotOptions: {
    area: {
      colors: [
        "#007fd8",
        "#ed8e88",
        "#e66e6d",
        "#de4f53",
        "#cf263d",
        "#c5ced5"
      ],
      stacking: "normal",
      lineWidth: 0,
      marker: {
        enabled: false,
        symbol: "circle",
        radius: 2,
        states: { hover: { enabled: true } }
      }
    }
  },
  series: [
    { color: "#c5ced5", name: "Under Process", data: [1, 1, 1, 1, 1, 1, 1] },
    { color: "#cf263d", name: "Deferred", data: [2, 1, 1, 1, 1, 1, 1] },
    { color: "#de4f53", name: "Partial Delayed", data: [1, 1, 1, 1, 1, 1, 1] },
    { color: "#e66e6d", name: "In Full Delayed", data: [1, 1, 1, 1, 1, 1, 1] },
    { color: "#ed8e88", name: "OT Partial", data: [2, 1, 1, 1, 1, 2, 1] },
    { color: "#007fd8", name: "OTIF", data: [90, 95, 94, 93, 94, 94, 92] }
  ]
};
export const barChart = {
  chart: { type: "column" },
  title: { text: "" },
  xAxis: { categories: ["North", "East", "West", "South"] },
  yAxis: {
    min: 0,
    max: 110,
    title: { text: "Percentage" },
    stackLabels: {
      enabled: true,
      style: {
        fontWeight: "bold",
        color:
          (Highcharts.defaultOptions.title.style &&
            Highcharts.defaultOptions.title.style.color) ||
          "gray"
      }
    }
  },
  legend: { enabled: true },
  tooltip: {
    headerFormat: "<b>{point.x}</b><br/>",
    pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}"
  },
  plotOptions: {
    column: {
      pointPadding: 0,
      borderWidth: 0,
      stacking: "normal",
      lineWidth: 0,
      dataLabels: { enabled: true }
    }
  },
  series: [
    { color: "#c5ced5", name: "Under Process", data: [5, 5, 6, 7] },
    { color: "#cf263d", name: "Deferred", data: [5, 5, 6, 7] },
    { color: "#de4f53", name: "Partial Delayed", data: [5, 5, 4, 4] },
    { color: "#e66e6d", name: "In Full Delayed", data: [8, 6, 5, 5] },
    { color: "#ed8e88", name: "OT Partial", data: [5, 10, 10, 3] },
    { color: "#007fd8", name: "OTIF", data: [50, 65, 64, 50] }
  ]
};

export const TABLE1 = [
  { state: 1, value: "a", amount: 1.0079, num: "e" },
  { state: 2, value: "b", amount: 4.0026, num: "f" },
  { state: 3, value: "c", amount: 6.941, num: "g" },
  { state: 4, value: "d", amount: 9.0122, num: "h" },
  { state: 5, value: "e", amount: 10.811, num: "i" }
];
export const TABLE2 = [
  { customer: 1, value: "a", amount: 1.0079, num: "e" },
  { customer: 2, value: "b", amount: 4.0026, num: "f" },
  { customer: 3, value: "c", amount: 6.941, num: "g" },
  { customer: 4, value: "d", amount: 9.0122, num: "h" },
  { customer: 5, value: "e", amount: 10.811, num: "i" }
];
export const TABLE3 = [
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" }
];
export const TABLE4 = [
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" }
];
export const TABLE5 = [
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" },
  { pair: 1, OTIF: "a", value: 1.0079, quantity: "e" }
];

// Initial tries
export const options1 = {
  chart: { type: "scatter", height: 400 },
  title: { text: "" },
  credits: { enabled: false },
  tooltip: {
    formatter: function() {
      return (
        "x: " +
        Highcharts.dateFormat("%e %b %y %H:%M:%S", this.x) +
        " y: " +
        this.y.toFixed(2)
      );
    }
  },
  xAxis: {
    type: "datetime",
    labels: {
      formatter: function() {
        return Highcharts.dateFormat("%e %b %y", this.value);
      }
    }
  },
  series: [
    {
      name: "Normal",
      turboThreshold: 500000,
      data: [
        [new Date("2018-01-25 18:38:31").getTime(), 2],
        [new Date("2018-01-26 18:38:31").getTime(), 3],
        [new Date("2018-01-27 18:38:31").getTime(), 4],
        [new Date("2018-01-28 18:38:31").getTime(), 5],
        [new Date("2018-01-29 18:38:31").getTime(), 3]
      ]
    },
    {
      name: "Abnormal",
      turboThreshold: 500000,
      data: [[new Date("2018-02-05 18:38:31").getTime(), 7]]
    }
  ]
};

export const options2 = {
  chart: { type: "column" },
  title: { text: "" },
  xAxis: { categories: ["Apples", "Oranges", "Pears", "Grapes", "Bananas"] },
  credits: { enabled: false },
  series: [{ name: "John", data: [-90, 3, 4, 7, 2] }]
};

export const options4 = {
  title: { text: "" },
  rangeSelector: {
    buttons: [
      { type: "hour", count: 1, text: "1h" },
      { type: "day", count: 1, text: "1D" },
      { type: "all", count: 1, text: "All" }
    ],
    selected: 1,
    inputEnabled: false
  },
  series: [
    {
      name: "AAPL",
      type: "candlestick",
      data: [
        [1317888000000, 372.5101, 375, 372.2, 372.52],
        [1317888060000, 372.4, 373, 372.01, 372.16],
        [1317888120000, 372.16, 372.4, 371.39, 371.62],
        [1317888180000, 371.62, 372.16, 371.55, 371.75],
        [1317888240000, 371.75, 372.4, 371.57, 372],
        [1317888300000, 372, 372.3, 371.8, 372.24],
        [1317888360000, 372.22, 372.45, 372.22, 372.3],
        [1317888420000, 372.3, 373.25, 372.3, 373.15],
        [1317888480000, 373.01, 373.5, 373, 373.24],
        [1317888540000, 373.36, 373.88, 373.19, 373.88],
        [1317888600000, 373.8, 374.34, 373.75, 374.29],
        [1317888660000, 374.29, 374.43, 374, 374.01],
        [1317888720000, 374.05, 374.35, 373.76, 374.35],
        [1317888780000, 374.41, 375.24, 374.37, 374.9],
        [1317888840000, 374.83, 375.73, 374.81, 374.96],
        [1317888900000, 374.81, 375.4, 374.81, 375.25],
        [1317888960000, 375.2, 375.7, 375.14, 375.19],
        [1317889020000, 375.43, 375.43, 374.75, 374.76],
        [1317889080000, 374.94, 375.5, 374.81, 375.13],
        [1317889140000, 375.12, 375.48, 375, 375.04],
        [1317889200000, 375.24, 375.24, 375, 375.08],
        [1317889260000, 375.16, 375.16, 374.51, 374.51]
      ],
      tooltip: {
        valueDecimals: 2
      }
    }
  ]
};
